import { useRef } from "react";
import { Link } from "react-router-dom";
import { useSiteChrome } from "@/lib/site";
import { SiteNav, SiteHero, PathBand, RevealSection, EarlyCta, ProblemSolution, scrollToLab } from "@/components/site/HomeTop";
import { Method, Audience, Proof, Outcomes, Founder, Pilot, Faq, SiteFooter } from "@/components/site/HomeBottom";
import { ResumeLab } from "@/components/site/ResumeLab";

export default function SiteHome() {
  useSiteChrome("Art of Resume | Turn experience into proof");
  const fileRef = useRef(null);
  const upload = () => { scrollToLab(); fileRef.current?.click(); };
  return (
    <div className="antialiased" data-testid="site-home">
      <a className="skipLink" href="#lab">Skip to resume diagnostic</a>
      <main>
        <SiteNav />
        <SiteHero onUpload={upload} />
        <PathBand />
        <RevealSection />
        <EarlyCta />
        <ProblemSolution />
        <ResumeLab ref={fileRef} />
        <Method />
        <Audience />
        <Proof />
        <Outcomes />
        <Founder />
        <Pilot />
        <Faq />
        <SiteFooter />
      </main>
      <Link className="serviceDock" to="/resume-service">Develop my resume →</Link>
    </div>
  );
}
